import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=6bc6341e&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=6bc6341e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6341e",
  null
  
)

export default component.exports